import {AuthoringStandardModelV1} from 'resources/GeneratedModels/AuthoringStandard/AuthoringStandardModel.v1';

import {AuthoringStandardModelValidators} from './AuthoringStandardModel.v1.validators';

AuthoringStandardModelV1.addValidators(AuthoringStandardModelValidators);

export {AuthoringStandardModelV1};
